export default __webpack_public_path__ + "static/media/FAQ_15_3.f4027ed6.png";